import { render, staticRenderFns } from "./TagFilterList.vue?vue&type=template&id=2fdc38a8&scoped=true&"
import script from "./TagFilterList.vue?vue&type=script&lang=js&"
export * from "./TagFilterList.vue?vue&type=script&lang=js&"
import style0 from "./TagFilterList.vue?vue&type=style&index=0&id=2fdc38a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc38a8",
  null
  
)

export default component.exports